import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Chart from 'chart.js';

function createDiagonalPattern(color = 'black') {
    const shape = document.createElement('canvas');
    shape.width = 10;
    shape.height = 10;
    const c = shape.getContext('2d');
    c.strokeStyle = color;
    c.fillStyle = 'green';
    c.fillRect(0, 0, shape.width, shape.height);
    c.beginPath();
    c.moveTo(2, 0);
    c.lineTo(10, 8);
    c.stroke();
    c.beginPath();
    c.moveTo(0, 8);
    c.lineTo(2, 10);
    c.stroke();
    return c.createPattern(shape, 'repeat');
}

class EmailsCharts extends React.PureComponent {
    constructor(props) {
        super(props);

        const { statisticsEmails } = props;

        this.state = {
            statisticsEmails,
            rangeDates: [],
            labels: [],
            datasets: [],
            chart: {},
        };
    }

    componentDidMount() {
        this.createRangeDates();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { statisticsEmails, showNormalized } = nextProps;

        if (!statisticsEmails.length) {
            return;
        }

        this.setState({
            statisticsEmails,
        }, () => {
            this.createRangeDates(showNormalized);
        });
    }

    createRangeDates(showNormalized) {
        let { statisticsEmails, chart } = this.state;

        const MAX = 100;

        const labels = [];

        const varamarSpam = [];
        const varamarSent = [];
        const varamarSentManual = [];
        const varamarFailed = [];

        const shipnextSpam = [];
        const shipnextSent = [];
        const shipnextSentManual = [];
        const shipnextFailed = [];

        const connectSpam = [];
        const connectSent = [];
        const connectFailed = [];

        const brokerSpam = [];
        const brokerSent = [];
        const brokerSentManual = [];
        const brokerFailed = [];

        statisticsEmails.forEach((item) => {
            labels.push(moment(item.realDate).format('MM-DD-YYYY'));

            let num = (item.varamar.failed || 0) + (item.varamar.sent || 0) + (item.varamar.spam || 0) + (item.varamar.totalSentManual || 0);

            let rate = showNormalized ? num / MAX : 1;
            
            varamarSpam.push(rate === 0 ? 0 : (item.varamar.spam || 0) / rate);
            varamarSent.push(rate === 0 ? 0 : (item.varamar.sent || 0) / rate);
            varamarSentManual.push(rate === 0 ? 0 : (item.varamar.totalSentManual || 0) / rate);
            varamarFailed.push(rate === 0 ? 0 : (item.varamar.failed || 0) / rate);

            num = (item.shipnext.failed || 0) + (item.shipnext.sent || 0) + (item.shipnext.spam || 0) + (item.shipnext.totalSentManual || 0);
            rate = showNormalized ? num / MAX : 1;

            shipnextSpam.push(rate === 0 ? 0 : (item.shipnext.spam || 0) / rate);
            shipnextSent.push(rate === 0 ? 0 : (item.shipnext.sent || 0) / rate);
            shipnextSentManual.push(rate === 0 ? 0 : (item.shipnext.totalSentManual || 0) / rate);
            shipnextFailed.push(rate === 0 ? 0 : (item.shipnext.failed || 0) / rate);

            num = (item.api.failed || 0) + (item.api.sent || 0) + (item.api.spam || 0);
            rate = showNormalized ? num / MAX : 1;

            connectSpam.push(rate === 0 ? 0 : (item.api.spam || 0) / rate);
            connectSent.push(rate === 0 ? 0 : (item.api.sent || 0) / rate);
            connectFailed.push(rate === 0 ? 0 : (item.api.failed || 0) / rate);

            num = (item.broker.failed || 0) + (item.broker.sent || 0) + (item.broker.spam || 0) + (item.broker.totalSentManual || 0);
            rate = showNormalized ? num / MAX : 1;

            brokerSpam.push(rate === 0 ? 0 : (item.broker.spam || 0) / rate);
            brokerSent.push(rate === 0 ? 0 : (item.broker.sent || 0) / rate);
            brokerSentManual.push(rate === 0 ? 0 : (item.broker.totalSentManual || 0) / rate);
            brokerFailed.push(rate === 0 ? 0 : (item.broker.failed || 0) / rate);
        });

        const postfix = showNormalized ? ' (%)' : '';

        const datasets = [
            // varamar
            {
                label: `Varamar spam${postfix}`,
                backgroundColor: 'blue',
                borderColor: 'blue',
                stack: 'Stack 0',
                data: varamarSpam,
            }, 
            {
                label: `Varamar sent${postfix}`,
                backgroundColor: 'green',
                borderColor: 'green',
                stack: 'Stack 0',
                data: varamarSent,
            }, 
            {
                label: `Varamar sent (manual)${postfix}`,
                backgroundColor: createDiagonalPattern('white'),
                borderColor: 'green',
                stack: 'Stack 0',
                data: varamarSentManual,
            }, 
            {
                label: `Varamar failed${postfix}`,
                backgroundColor: 'red',
                borderColor: 'red',
                stack: 'Stack 0',
                data: varamarFailed,
            }, 

            // shipnext
            {
                label: `Shipnext spam${postfix}`,
                backgroundColor: 'blue',
                borderColor: 'blue',
                stack: 'Stack 1',
                data: shipnextSpam,
            }, 
            {
                label: `Shipnext sent${postfix}`,
                backgroundColor: 'green',
                borderColor: 'green',
                stack: 'Stack 1',
                data: shipnextSent,
            }, 
            {
                label: `Shipnext sent (manual)${postfix}`,
                backgroundColor: createDiagonalPattern('white'),
                borderColor: 'green',
                stack: 'Stack 1',
                data: shipnextSentManual,
            }, 
            {
                label: `Shipnext failed${postfix}`,
                backgroundColor: 'red',
                borderColor: 'red',
                stack: 'Stack 1',
                data: shipnextFailed,
            }, 

            // connect
            {
                label: `Connect spam${postfix}`,
                backgroundColor: 'blue',
                borderColor: 'blue',
                stack: 'Stack 2',
                data: connectSpam,
            }, 
            {
                label: `Connect sent${postfix}`,
                backgroundColor: 'green',
                borderColor: 'green',
                stack: 'Stack 2',
                data: connectSent,
            }, 
            {
                label: `Connect failed${postfix}`,
                backgroundColor: 'red',
                borderColor: 'red',
                stack: 'Stack 2',
                data: connectFailed,
            }, 

            // broker
            {
                label: `Broker spam${postfix}`,
                backgroundColor: 'blue',
                borderColor: 'blue',
                stack: 'Stack 3',
                data: brokerSpam,
            }, 
            {
                label: `Broker sent${postfix}`,
                backgroundColor: 'green',
                borderColor: 'green',
                stack: 'Stack 3',
                data: brokerSent,
            }, 
            {
                label: `Broker sent (manual)${postfix}`,
                backgroundColor: createDiagonalPattern('white'),
                borderColor: 'green',
                stack: 'Stack 3',
                data: brokerSentManual,
            }, 
            {
                label: `Broker failed${postfix}`,
                backgroundColor: 'red',
                borderColor: 'red',
                stack: 'Stack 3',
                data: brokerFailed,
            }];

        if (_.isEmpty(this.state.chart)) {
            chart = this.createChart(labels, datasets);
        } else {
            chart = this.updateChart(chart, labels, datasets);
        }

        this.setState({
            labels,
            datasets,
            chart,
        });
    }

    updateChart(chart, labels, datasets) {
        chart.data.labels = labels;
        chart.data.datasets = datasets;

        if (this.props.showNormalized) {
            chart.options.scales.yAxes = [{
                stacked: true,
                ticks: {
                    max: 100,
                },
            }];
        } else {
            chart.options.scales.yAxes = [{
                stacked: true,
            }];
        }

        chart.update(0);

        return chart;
    }

    createChart(labels, datasets) {
        const ctx = this.refs.chart.getContext('2d');
        const chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets,
            },
            options: {
                tooltips: {
                    mode: 'label',
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        stacked: true,
                    }],
                },
            },
        });

        return chart;
    }

    render() {
        return (
            <div className='row'>
                <div className='col-xs-12'>
                    <canvas ref='chart' />
                </div>
            </div>
        );
    }
}

export default connect(
    ({ statisticsEmails: { items, searchText } }, { from, until }) => ({
        statisticsEmails: items,
        searchText,
        from,
        until,
    }),
    dispatch => bindActionCreators(
        {

        },
        dispatch,
    ),
)(EmailsCharts);



// WEBPACK FOOTER //
// ./app/components/Statistics/Emails/Charts.jsx